const state = {
  isShow: false,
};

const getters = {
  VersionControlShow: state => state.isShow,
};

const mutations = {
  set_VersionControlShow (state, flag) {
    state.isShow = flag;
  },
};

export default {
  namespaced: true,
  state,
  getters,
  mutations
};



// WEBPACK FOOTER //
// ./src/store/modules/versionControl.js